import { render, staticRenderFns } from "./TwoFactorSetup.vue?vue&type=template&id=4533cd42&scoped=true"
import script from "./TwoFactorSetup.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoFactorSetup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TwoFactorSetup.vue?vue&type=style&index=0&id=4533cd42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4533cd42",
  null
  
)

export default component.exports